// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Targeting AK test id as we can not include css-reset
/  as a dependency */
/* stylelint-disable plugin/no-data-test-selectors */
div[data-testid='spotlight--dialog'] h4 {
  margin-top: var(--ds-space-0, 0px);
}
div[data-testid='spotlight--dialog'] button {
  margin-bottom: var(--ds-space-0, 0px);
}
div[data-testid='spotlight--target'] {
  animation: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
